import { type ReactNode, useEffect } from "react";
import { usePreferencesState } from "@/store/hooks.ts";
import { useColorScheme } from "@mui/material";

type AutoThemeSwitcherProps = {
  children: ReactNode;
};

const AutoThemeSwitcher = ({ children }: AutoThemeSwitcherProps) => {
  const { mode } = usePreferencesState();
  const { setMode } = useColorScheme();

  useEffect(() => {
    setMode(mode);
  }, [mode, setMode]);

  return children;
};

export default AutoThemeSwitcher;
